module.exports = __webpack_public_path__ + "img/scene20.1573c317.gif";